import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Mission & Services", path: "/mission-services" },
  { label: "Groupes Business", path: "/groupes-business" },
  { label: "Recherche & Innovations", path: "/recherche-innovations" },
  { label: "Médias sociaux", path: "/medias-sociaux" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
      style={{ height: "80px" }}
    >
      <div className="max-w-7xl mx-auto px-6 h-full flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/2ff205c826c7478ce4cffa1fe381bc88/8b53dd28b3301c749b5023c4bbcf750b.png"
            alt="Stéphane Boutin Logo"
            className="h-12 w-12 object-contain rounded-full"
          />
          <span
            className={`font-semibold text-sm tracking-widest uppercase transition-colors duration-300 ${
              scrolled ? "text-gray-800" : "text-white"
            }`}
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            stephane-boutin.com
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium tracking-wide transition-all duration-200 whitespace-nowrap relative group cursor-pointer ${
                scrolled ? "text-gray-700 hover:text-gray-900" : "text-white/90 hover:text-white"
              } ${location.pathname === link.path ? "font-semibold" : ""}`}
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              {link.label}
              <span
                className={`absolute -bottom-1 left-0 h-0.5 bg-amber-500 transition-all duration-300 ${
                  location.pathname === link.path ? "w-full" : "w-0 group-hover:w-full"
                }`}
              />
            </Link>
          ))}
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <span className={`block w-6 h-0.5 transition-all duration-300 ${scrolled ? "bg-gray-800" : "bg-white"}`} />
          <span className={`block w-6 h-0.5 transition-all duration-300 ${scrolled ? "bg-gray-800" : "bg-white"}`} />
          <span className={`block w-6 h-0.5 transition-all duration-300 ${scrolled ? "bg-gray-800" : "bg-white"}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="block px-6 py-4 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900 border-b border-gray-50 cursor-pointer"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}
